/**
 * DOM leaderboard modal. Fetches the top slots for a cartridge (scoped
 * to the remastered cartridge_version) and renders a classic AAA table.
 */

import { getLeaderboard } from '../api/client.js';
import type { CatalogEntry } from '../catalog.js';

export function openLeaderboard(entry: CatalogEntry): void {
  const modal = document.getElementById('leaderboard-modal');
  const title = document.getElementById('leaderboard-title');
  const list = document.getElementById('leaderboard-list');
  const closeBtn = document.getElementById('leaderboard-close');
  if (
    !(modal instanceof HTMLElement) ||
    !(title instanceof HTMLElement) ||
    !(list instanceof HTMLElement) ||
    !(closeBtn instanceof HTMLButtonElement)
  ) {
    return;
  }

  title.textContent = entry.title;
  title.style.color = entry.accent;
  list.textContent = '';
  const loading = document.createElement('li');
  loading.className = 'leaderboard__row leaderboard__row--empty';
  loading.textContent = 'DIALING THE SCOREBOARD…';
  list.appendChild(loading);

  const close = (): void => {
    modal.hidden = true;
    closeBtn.removeEventListener('click', close);
    window.removeEventListener('keydown', onKey, true);
  };
  const onKey = (e: KeyboardEvent): void => {
    if (e.key === 'Escape') {
      e.stopPropagation();
      close();
    }
  };
  closeBtn.addEventListener('click', close);
  window.addEventListener('keydown', onKey, true);
  modal.hidden = false;
  closeBtn.focus();

  void getLeaderboard(entry.id, {
    period: 'all',
    limit: 10,
    cartridgeVersion: entry.validatorVersion,
  })
    .then((board) => {
      if (modal.hidden) return;
      list.textContent = '';
      if (board.scores.length === 0) {
        const empty = document.createElement('li');
        empty.className = 'leaderboard__row leaderboard__row--empty';
        empty.textContent = 'NO SCORES YET — THE BOARD IS YOURS';
        list.appendChild(empty);
        return;
      }
      board.scores.forEach((row, i) => {
        const li = document.createElement('li');
        li.className = 'leaderboard__row';
        const rank = document.createElement('span');
        rank.className = 'leaderboard__rank';
        rank.textContent = String(i + 1).padStart(2, '0');
        const who = document.createElement('span');
        who.className = 'leaderboard__initials';
        who.textContent = row.initials || '???';
        const score = document.createElement('span');
        score.className = 'leaderboard__score';
        score.textContent = String(row.score).padStart(6, '0');
        li.append(rank, who, score);
        list.appendChild(li);
      });
    })
    .catch(() => {
      if (modal.hidden) return;
      list.textContent = '';
      const err = document.createElement('li');
      err.className = 'leaderboard__row leaderboard__row--empty';
      err.textContent = 'SCOREBOARD UNREACHABLE — TRY AGAIN LATER';
      list.appendChild(err);
    });
}
